
import { defineComponent, reactive, ref } from 'vue'
import { imageUpload, postNewPost, getContent } from '@/api'
import { useStore } from 'vuex'
import axios from 'axios'
import Button from '@/components/btn.vue'
import Card from '@/components/Card.vue'
import bus from '@/plugins/bus'
import { useToast } from 'vue-toastification'
export interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
export interface Post {
  title: string;
  article: string;
  photo: string;
  images?: string[];
  category: string;
  _id?: string;
  id?: string;
}
export default defineComponent({
  name: 'Post',
  components: {
    Button,
    Card
  },
  setup () {
    const store = useStore()
    const toast = useToast()
    const postData = reactive<Post>({
      title: '',
      article: '',
      photo: '',
      images: [],
      category: ''
    })
    const otherImages = reactive({ images: [] as File[] })
    const recentPosts = reactive({ data: [] as Post[] })
    const imageName = ref('')
    const imageThumb = ref('')
    const category = ref('')
    const otherShow = ref(false)
    const updateIndex = (id: string) => {
      return (recentPosts.data.indexOf(recentPosts.data.filter((item: Post) => item.id === id)[0]))
    }
    bus.on('update-open', (id) => updateIndex(id))
    const putImage = (e: HTMLInputEvent, index: number) => {
      if (!e.target.files) return
      otherImages.images.length = 5
      otherImages.images[index] = e.target.files[0]
    }
    const uploadToImgur = async (e: HTMLInputEvent) => {
      try {
        if (!e.target.files) return
        const file: File = e.target.files[0]
        imageName.value = file.name
        imageThumb.value = window.URL.createObjectURL(file)
        const form: FormData = new FormData()
        form.append('title', imageName.value)
        form.append('image', file)
        const { data } = await imageUpload(form)
        if (data.status === 200) {
          toast.success('image uploaded successfully')
          postData.photo = data.data.link
        }
      } catch (error) {
        toast.error('OPPS! something wrong during the process')
      }
    }
    const uploadOthers = async () => {
      try {
        toast.info('Start uploading, it might take some time')
        otherImages.images = otherImages.images.filter(item => item !== undefined)
        const imgArr = await Promise.all(otherImages.images.map(image => {
          const form = new FormData()
          form.append('image', image)
          return imageUpload(form)
        }))
        if (imgArr[imgArr.length - 1].status === 200) {
          toast.success(`${imgArr.length} images uploaded successfully`)
          otherImages.images.length = 0
        }
        postData.images = imgArr.map(img => img.data.data.link)
      } catch (error) {
        toast.error('OPPS! something wrong during the process')
      }
    }
    const getPosts = async () => {
      try {
        store.dispatch('loading')
        const res = await getContent(1, 5)
        recentPosts.data = res.data.data
        if (res.data.state === 'success') {
          store.dispatch('loading')
        }
      } catch (error) {
        toast.error('error')
        store.dispatch('loading')
      }
    }
    const newPost = async () => {
      try {
        store.dispatch('loading')
        const res = await postNewPost(postData)
        if (res.status === 201) {
          await toast.success('New article posted')
          store.dispatch('loading')
          postData.title = ''
          postData.article = ''
          postData.photo = ''
          imageThumb.value = ''
          getPosts()
        }
      } catch (error) {
        store.dispatch('loading')
        toast.error('An error occurred while posting')
      }
    }
    getPosts()
    return {
      uploadToImgur,
      imageName,
      imageThumb,
      postData,
      newPost,
      recentPosts,
      otherShow,
      uploadOthers,
      otherImages,
      putImage,
      category
      // title,
      // description
    }
  }
})
